module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-3-photo-12-a4e85a1befaff761970c203beed59f97.webp";